import { createApi } from '@reduxjs/toolkit/query/react';
import { apiResources } from 'src/common/Constants';
import type { TMarket, TMarketsRequestDTO } from 'src/common/types/market.type';
import type { TSearchFilter, TSearchResponse } from 'src/typings/app.type';
import { baseQueryWithAuth, transformResponses } from '../rtkq.interceptor';

const marketTag = 'market';
export const marketApi = createApi({
  reducerPath: 'marketApi',
  tagTypes: [marketTag],
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getRates: builder.query<TSearchResponse<TMarket>, TSearchFilter & TMarketsRequestDTO>({
      providesTags: [marketTag],
      query: (params) => ({ url: `${apiResources.marketRate}/all`, params }),
      ...transformResponses,
    }),
    uploadRates: builder.mutation<string, File>({
      query: (csv) => {
        const formData = new FormData();
        formData.append('file', csv);
        return { url: `${apiResources.marketRate}/upload`, method: 'POST', body: formData };
      },
      ...transformResponses,
      invalidatesTags: (_result, error) => (error ? [] : [marketTag]),
    }),
  }),
});

export const { useGetRatesQuery, useUploadRatesMutation } = marketApi;
